<template>
	<v-slide-item>
		<v-menu	close-delay
				offset-y
				:dark="$_cmSldItm_styleCollapsedMenuDark"
				:light="$_cmSldItm_styleCollapsedMenuLight">
			<template v-slot:activator="{ on }">
				<v-btn	class="customVBtn mr-2"
						:block="$_cmSldItm_styleMenuButtonBlock"
						:color="$_cmSldItm_styleMenuButtonColor"
						:dark="$_cmSldItm_styleMenuButtonDark"
						:depressed="$_cmSldItm_styleMenuButtonDepressed"
						:elevation="$_cmSldItm_styleMenuButtonElevation"
						:large="$_cmSldItm_styleMenuButtonLarge"
						:light="$_cmSldItm_styleMenuButtonLight"
						:outlined="$_cmSldItm_styleMenuButtonOutlined"
						:rounded="$_cmSldItm_styleMenuButtonRounded"
						:small="$_cmSldItm_styleMenuButtonSmall"
						:text="$_cmSldItm_styleMenuButtonFlat"
						v-on="on">
					<v-row no-gutters align="center">
						<v-col class="center">
							<v-icon	:color="contents[contentKey].iconColor"
									v-text="contents[contentKey].icon || 'arrow_drop_down'" />
						</v-col>
						<template v-if="!isFalse($_cmSldItm_langContentTitle(contents[contentKey]))">
							<v-col class="ml-2 center">
								<span	class="overline" 
										v-html="$_cmSldItm_langContentTitle(contents[contentKey])" />
							</v-col>
						</template>
						<template v-if="debugMode">
							<v-col class="ml-2" cols="auto">
								<debugger-order-alert :order="contents[contentKey].order" />
							</v-col>
						</template>
					</v-row>
				</v-btn>
			</template>
			<v-list>
				<template v-for="(menuItemVals, menuItemKey) in sortObject($_cmSldItm_appMenuItemsContentsIsCollapsedMenu, 'order')">
					<template v-if="$_cmSldItm_checkMenu(menuItemVals, contentKey) && checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
						<v-btn	:key="menuItemKey"
								class="customVBtn button_"

								:block="$_cmSldItm_styleCollapsedMenuButtonBlock"
								:color="$_cmSldItm_styleCollapsedMenuButtonColor"
								:dark="$_cmSldItm_styleCollapsedMenuButtonDark"
								:depressed="$_cmSldItm_styleCollapsedMenuButtonDepressed"
								:elevation="$_cmSldItm_styleCollapsedMenuButtonElevation"
								:large="$_cmSldItm_styleCollapsedMenuButtonLarge"
								:light="$_cmSldItm_styleCollapsedMenuButtonLight"
								:outlined="$_cmSldItm_styleCollapsedMenuButtonOutlined"
								:rounded="$_cmSldItm_styleCollapsedMenuButtonRounded"
								:small="$_cmSldItm_styleCollapsedMenuButtonSmall"
								:text="$_cmSldItm_styleCollapsedMenuButtonFlat"
								:tile="$_cmSldItm_styleCollapsedMenuButtonTile"

								@click="openLink(menuItemVals.link)">
							<v-row dense align="center">
								<template v-if="menuItemVals.icon">
									<v-col class="center" cols="auto">
										<v-icon :color="menuItemVals.iconColor"
												v-text="menuItemVals.icon" />
									</v-col>
								</template>
								<v-col class="center" cols="auto">
									<span	class="overline" 
											v-html="$_cmSldItm_langAppMenuTitle(menuItemVals)" />
								</v-col>
								<template v-if="debugMode">
									<v-spacer />
									<v-col cols="auto">
										<debugger-order-alert :order="menuItemVals.order" />
									</v-col>
								</template>
							</v-row>
						</v-btn>
					</template>
				</template>
			</v-list>
		</v-menu>
	</v-slide-item>
</template>

<script>
	export default {
		name: 'CollapsedMenuSlideItem',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// app menu items
			$_cmSldItm_appMenuItemsContents() {
				const self_ = this;
				const contents_ = self_.getAppContents('menuItems')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_cmSldItm_appMenuItemsContentsIsCollapsedMenu() {
				const self_ = this;
				const menuItems_ = self_.$_cmSldItm_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isCollapsedMenu', true)
			},
			$_cmSldItm_appMenuItemsInits() {
				const self_ = this;
				return self_.getAppInits('menuItems')
			},
			$_cmSldItm_langAppMenuTitle() {
				const self_ = this;
				return menuItemVals => {
					if(self_.isFalse(menuItemVals.title)) { return null }
					return self_.getLangsVal(menuItemVals.title)
				}
			},
			// lang
			$_cmSldItm_langContentTitle() {
				const self_ = this;
				return menuItemVals => {
					const title_ = menuItemVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}				
			},
			// style
			$_cmSldItm_styleCollapsedMenu() {
				const self_ = this;
				if(self_.isEmpty(self_.inits)) { return null }
				return self_.getInitsStyleVal(self_.inits, 'collapsedMenu')
			},
			$_cmSldItm_styleCollapsedMenuDark() {
				const self_ = this;
				const menu_ = self_.$_cmSldItm_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.dark)
			},
			$_cmSldItm_styleCollapsedMenuLight() {
				const self_ = this;
				const menu_ = self_.$_cmSldItm_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.light)
			},
			$_cmSldItm_styleMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'menuButton')
			},
			$_cmSldItm_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_cmSldItm_styleMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_cmSldItm_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_cmSldItm_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_cmSldItm_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_cmSldItm_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_cmSldItm_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_cmSldItm_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_cmSldItm_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_cmSldItm_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_cmSldItm_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_cmSldItm_styleMenuButtonTile() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.tile)
			},
			$_cmSldItm_styleCollapsedMenuButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'collapsedMenuButton')
			},
			$_cmSldItm_styleCollapsedMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_cmSldItm_styleCollapsedMenuButtonColor() {
				const self_ = this;
				const button_ =self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_cmSldItm_styleCollapsedMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_cmSldItm_styleCollapsedMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_cmSldItm_styleCollapsedMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_cmSldItm_styleCollapsedMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_cmSldItm_styleCollapsedMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_cmSldItm_styleCollapsedMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_cmSldItm_styleCollapsedMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_cmSldItm_styleCollapsedMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_cmSldItm_styleCollapsedMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_cmSldItm_styleCollapsedMenuButtonTile() {
				const self_ = this;
				const button_ = self_.$_cmSldItm_styleCollapsedMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.tile)
			}
		},
		methods: {
			$_cmSldItm_checkMenu(menu, key) {
				const self_ = this;
				if(self_.isEmpty(menu.menu)) { return false }
				return menu.menu[key]
			}
		}
	}
</script>

<style scoped>
	.button_ {
		width: 100%;
		text-align: left;
	}
	.v-menu__content {
		max-width: 35% !important;
	}
</style>
